export default __webpack_public_path__ + "static/media/fireFN22.5dcc09d1.svg";